import { render, staticRenderFns } from "./SpotRegulations.vue?vue&type=template&id=8252bf72&scoped=true&"
import script from "./SpotRegulations.vue?vue&type=script&lang=js&"
export * from "./SpotRegulations.vue?vue&type=script&lang=js&"
import style0 from "./SpotRegulations.vue?vue&type=style&index=0&id=8252bf72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8252bf72",
  null
  
)

export default component.exports